import { render, staticRenderFns } from "./AccueilNew.vue?vue&type=template&id=bba71102"
import script from "./AccueilNew.vue?vue&type=script&lang=js"
export * from "./AccueilNew.vue?vue&type=script&lang=js"
import style0 from "./AccueilNew.vue?vue&type=style&index=0&id=bba71102&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports